import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SessionUser {
  id: string
  email: string
  role: string
  display_name: string | null
  avatar: string | null
}

interface SessionState {
  status: 'checking' | 'authenticated' | 'anonymous' | 'forbidden'
  user: SessionUser | null
}

const initialState: SessionState = { status: 'checking', user: null }

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    authenticated(state, action: PayloadAction<SessionUser>) {
      state.status = 'authenticated'
      state.user = action.payload
    },
    anonymous(state) { state.status = 'anonymous'; state.user = null },
    forbidden(state, action: PayloadAction<SessionUser>) { state.status = 'forbidden'; state.user = action.payload },
  },
})

export const sessionActions = sessionSlice.actions
export const sessionReducer = sessionSlice.reducer
export type { SessionState }
